import { useUser } from "src/common/context/userContextUtils.js";
import { useDevToolsUnlockListener } from "./useDevToolsUnlock.js";

/** The one mount point for the `§§§` handler — see `useDevToolsUnlockListener`.
 * A component rather than a hook call in `ProtectedApp` itself, because it needs
 * to sit inside `<ProvideUser>` to read the super-admin flag. */
export const DevToolsUnlockListener = () => {
	const { userIsSuperAdmin } = useUser();
	useDevToolsUnlockListener(userIsSuperAdmin());
	return null;
};
